import { Pipe, PipeTransform } from '@angular/core';
import { SelectItem } from 'primeng/primeng';

/*
 * Converts decimal/float to time representation
 * Usage:
 *  decimal/float | decToTime
*/

@Pipe({
  name: 'decToTime'
})
export class DecToTimePipe implements PipeTransform {

  transform(value: string): string {
    if(value == null)
      return '-';
    if( value.toString().indexOf('.') !== -1 ){
      let dec = Math.round(parseFloat("0."+String(value).split('.')[1]) * 60).toString();
      return (parseInt(String(value).split('.')[0]) + ':' + dec).toString();
    }
    return value;
  }
}


// WEBPACK FOOTER //
// ./src/app/util/pipe-cargahoraria.ts